exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".register-form{background-color:#fff;display:inline-block;width:100%}", "", {"version":3,"sources":["/home/steven/dev/Sporte/sporte2/src/components/RegisterForm.vue"],"names":[],"mappings":"AACA,eACE,sBAAwB,AACxB,qBAAsB,AACtB,UAAY,CACb","file":"RegisterForm.vue","sourcesContent":["\n.register-form  {\n  background-color: white;\n  display: inline-block;\n  width: 100%;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ec31dcee","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/RegisterForm.vue
// module id = 878
// module chunks = 2